export default "__VITE_ASSET__bb11cd23__"